<template>
  <div>
    <v-dialog v-model="dialog" max-width="900px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" dark v-bind="attrs" v-on="on">
          Nuevo Descuento
        </v-btn>
      </template>
      <DiscountForm
        :value="currentDiscount"
        :property-code-options="propertyCodeOptions"
        :role-options="roleOptions"
        :is-editing="isEditing"
        @submit="handleSubmit"
        @cancel="closeDialog"
      />
    </v-dialog>

    <DiscountTable
      :discounts="discounts"
      @edit="handleEdit"
      @delete="handleConfirmDelete"
    />
  </div>
</template>

<script>
import DiscountForm from "./Form.vue";
import DiscountTable from "./Table.vue";
import {
  CreateDiscount,
  UpdateDiscount,
  deleteDiscount
} from "@/api/real-estate-pricing-rules-api";

const INITIAL_DISCOUNT = {
  method_discount: "",
  discount: "",
  months_discount: "",
  description_method_discount: "",
  properties_apply_discount: "",
  condition: "",
  propertys_code: [],
  allowed_entities: ["role:admin"]
};

export default {
  name: "DiscountManager",
  components: {
    DiscountForm,
    DiscountTable
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    realEstateID: {
      type: String,
      required: true
    },
    propertyCodeOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialog: false,
      currentDiscount: { ...INITIAL_DISCOUNT },

      editedIndex: -1,
      roleOptions: [{ description: "Broker", value: "role:broker" }]
    };
  },
  computed: {
    isEditing() {
      return this.editedIndex > -1;
    },
    discounts: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("input", newVal);
      }
    }
  },
  methods: {
    handleSubmit(formData) {
      if (this.isEditing) {
        this.updateDiscount(formData);
      } else {
        this.createDiscount(formData);
      }
    },
    createDiscount(discountData) {
      const payload = {
        ...discountData,
        real_estate_development: this.realEstateID
      };

      this.$snotify.async(
        "Creando Descuento",
        "Procesando ...",
        () =>
          new Promise((resolve, reject) => {
            setTimeout(() => {
              CreateDiscount(payload, this.realEstateID)
                .then(res => {
                  this.discounts.push(res.Discount);
                  this.closeDialog();
                  resolve({
                    title: "Descuento",
                    body: "Creado correctamente",
                    config: {
                      closeOnClick: true,
                      titleMaxLength: 30,
                      timeout: 4000
                    }
                  });
                })
                .catch(err => {
                  reject({
                    title: "Error!!!",
                    body: `Ocurrió un problema en el proceso. ${err}`,
                    config: {
                      closeOnClick: true,
                      timeout: 4000
                    }
                  });
                });
            }, 500);
          })
      );
    },
    updateDiscount(discountData) {
      const discountId = this.discounts[this.editedIndex]._id;

      this.$snotify.async(
        "Actualizando Descuento",
        "Actualizando ...",
        () =>
          new Promise((resolve, reject) => {
            setTimeout(() => {
              UpdateDiscount(discountData, discountId)
                .then(() => {
                  Object.assign(this.discounts[this.editedIndex], discountData);
                  this.closeDialog();
                  resolve({
                    title: "Descuento",
                    body: "Actualizado correctamente",
                    config: {
                      closeOnClick: true,
                      titleMaxLength: 30,
                      timeout: 4000
                    }
                  });
                })
                .catch(err => {
                  reject({
                    title: "Error!!!",
                    body: `Ocurrió un problema en el proceso. ${err}`,
                    config: {
                      closeOnClick: true,
                      timeout: 4000
                    }
                  });
                });
            }, 500);
          })
      );
    },
    handleEdit(discount) {
      this.editedIndex = this.discounts.indexOf(discount);
      this.currentDiscount = { ...discount };
      this.dialog = true;
    },
    handleConfirmDelete(discount) {
      this.$confirmation(
        "Eliminar Descuento",
        "¿Estás seguro que deseas eliminar este descuento?",
        () => this.deleteDiscount(discount)
      );
    },
    deleteDiscount(discount) {
      this.$snotify.async(
        "Eliminando Descuento",
        "Eliminando ...",
        () =>
          new Promise((resolve, reject) => {
            setTimeout(() => {
              deleteDiscount(discount._id)
                .then(() => {
                  this.discounts.splice(this.discounts.indexOf(discount), 1);
                  resolve({
                    title: "Descuento",
                    body: "Eliminado correctamente",
                    config: {
                      closeOnClick: true,
                      titleMaxLength: 30,
                      timeout: 4000
                    }
                  });
                })
                .catch(err => {
                  const errorMessage = err.message.includes("esta siendo usado")
                    ? "Descuento actualmente en uso, por favor elimine primero la regla de precio asociada"
                    : "Ocurrió un problema en el proceso";

                  reject({
                    title: "Error",
                    body: errorMessage,
                    config: {
                      closeOnClick: true,
                      timeout: 4000
                    }
                  });
                });
            }, 500);
          })
      );
    },
    closeDialog() {
      this.dialog = false;
      this.$nextTick(() => {
        this.currentDiscount = { ...INITIAL_DISCOUNT };
        this.editedIndex = -1;
      });
    }
  }
};
</script>
